<template>
  <Main>
    <fragment v-if="hasCurrentPolicy">
      <v-row class="pb-8">
        <v-col cols="12" md="3" class="details-policy__title">
          <p class="primary--text form__title mb-7 mb-md-0">
            DETALHE DA APÓLICE
          </p>
        </v-col>
        <v-spacer />
        <v-col
          cols="12"
          sm="5"
          md="3"
          :class="'pb-5 pb-sm-0 ' + classButtonCriticism"
          v-if="currentPolicy.cotacao"
        >
          <BaseButton
            outlined
            color="secondary"
            v-html="'ACOMPANHAR CRÍTICAS'"
            width="100%"
            @click="redirectToCriticism"
          />
        </v-col>
        <v-col
          cols="12"
          sm="3"
          md="3"
          lg="2"
          :class="classButtonEditPolicy"
          v-if="canSeeEditPolicy"
        >
          <BaseButton
            class="secondary"
            v-html="'EDITAR APÓLICE'"
            width="100%"
            @click="editPolicy"
          />
        </v-col>
        <v-col
          cols="12"
          sm="4"
          md="3"
          xl="2"
          v-if="canCancelPolicy"
          class="pb-5 pb-sm-0 pl-sm-4 pl-md-0"
        >
          <BaseButton
            color="pink white--text"
            v-html="'CANCELAR APÓLICE'"
            width="100%"
            :to="{ name: 'cancel policy', params: $route.params }"
          />
        </v-col>
        <v-col
          cols="12"
          sm="4"
          md="3"
          v-if="hasResquestToCancelPolicy"
          class="pb-7 pl-sm-4 pb-sm-0"
        >
          <BaseButton
            class="pink white--text justify-center"
            width="100%"
            @click="showModalRefuseCancelPolicy"
            v-html="'RECUSAR CANCELAMENTO'"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" class="pr-md-5">
          <BaseFormInput
            id-element="takerPolicy"
            placeholder="Inserir"
            v-model="currentPolicy.tomador.nome_fantasia"
            validate-on-blur
            label-text="Grupo Econômico:"
            disabled
          />
        </v-col>
        <v-col cols="12" sm="6" md="3" class="pr-sm-5">
          <BaseFormInput
            id-element="requestedPolicy"
            placeholder="Inserir"
            v-model="currentPolicy.solicitada_por.nome"
            validate-on-blur
            label-text="Solicitado por:"
            disabled
          />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <BaseFormInput
            id-element="approvedPolicy"
            placeholder="Inserir"
            :value="
              currentPolicy.aprovada_por && currentPolicy.aprovada_por.nome
            "
            validate-on-blur
            label-text="Aprovado por:"
            disabled
          />
        </v-col>
        <v-col cols="12" md="6" class="pr-md-5 pb-5 pb-md-10">
          <CardInfoPolicy
            :item="currentPolicy"
            @open="openModal"
            @bills="openModalDocuments"
          />
        </v-col>
        <v-col cols="12" md="6" class="pb-5 pb-md-10">
          <CardOthersInfoPolicy :item="currentPolicy" />
        </v-col>
        <v-col cols="12">
          <CardPolicyCertificates :seguradoraId="currentPolicy.seguradora.id" />
        </v-col>
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>
      <v-row class="pt-8">
        <v-col cols="12" md="6" class="mb-5 mb-md-0 details-policy__title">
          <p class="primary--text form__title mb-0">
            DADOS DE FINANCEIROS (R$)
          </p>
        </v-col>
        <v-col cols="12" md="6" class="pl-md-5 mb-2">
          <v-row class="yellow px-2 py-3 details-policy__disclaimer">
            <p class="caption primary-text font-weight-bold mb-0">
              *O valor de prêmio emitido é referente a soma do prêmio da apólice
              + endossos.
            </p>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" class="pr-md-5 pb-10">
          <v-row class="details-policy__item pb-6 pt-5 px-6">
            <v-col cols="12">
              <p class="body-2 font-weight-bold lightestGray--text mb-0">
                Importância Segurada (Atual)
              </p>
              <p class="secondary--text details-policy__money mb-0">
                {{
                  asMoneyString(
                    currentPolicy.valor_importancia_segurada
                  ).replace("R$\u00A0", "")
                }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" class="pb-10">
          <v-row class="details-policy__item pb-6 pt-5 px-6">
            <v-col cols="12">
              <p class="body-2 font-weight-bold lightestGray--text mb-0">
                Total de prêmio emitido
              </p>
              <p class="lightestGray--text details-policy__money mb-0">
                {{
                  asMoneyString(currentPolicy.valor_premio).replaceAll(
                    "R$\u00A0",
                    ""
                  )
                }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>
      <v-row v-if="hasAnexos">
        <v-col
          cols="12"
          md="6"
          class="mb-5 mb-md-0 details-policy__title pt-8 pb-6"
        >
          <p class="primary--text form__title mb-0 pb-3">
            DOCUMENTOS ANEXOS
          </p>
          <DocumentDataTable
            :documents="currentPolicy.documentos_anexos"
            @preview-file="onPreviewFile"
            :disabled="true"
          />
        </v-col>
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>
      <BaseTab class="pt-8">
        <v-row>
          <v-col cols="auto" class="endorsement-list__col">
            <v-tab>ENDOSSOS</v-tab>
          </v-col>
          <v-col cols="auto" class="endorsement-list__col">
            <v-tab>SOLICITAÇÕES DE ENDOSSOS</v-tab>
          </v-col>
          <v-spacer class="d-none d-md-flex" />
          <v-col
            cols="12"
            md="3"
            xl="2"
            class="pb-md-0 d-none d-md-flex"
            v-if="canRequestEndorsement"
          >
            <BaseButton
              width="100%"
              outlined
              color="secondary"
              v-html="'SOLICITAR ENDOSSO'"
              @click="newRequestEndorsement"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            xl="2"
            class="pb-md-0 d-none d-md-flex"
            v-if="canAddNewEndorsement"
          >
            <BaseButton
              class="secondary white--text justify-start"
              width="100%"
              @click="newEndorsement"
            >
              <v-icon class="pr-0 pr-md-9 pr-xl-3">
                fa-plus
              </v-icon>
              NOVO ENDOSSO
            </BaseButton>
          </v-col>
        </v-row>
        <v-tab-item class="pt-5">
          <HeaderEndorsementTable
            :canSeeRequestEndorsement="canSeeRequestEndorsement"
            :canSeeNewEndorsement="canSeeNewEndorsement"
          />
          <v-row class="pt-3">
            <v-col cols="12">
              <BaseDataTable
                :headers="header"
                :items="currentPolicy.endossos"
                no-data-text="Nenhum Endosso foi encontrado"
                loading-text="Carregando Endossos..."
                class="details-policy__table"
                hide-default-footer
                @click:row="editEndorsement"
              >
                <template v-slot:[`item.numero`]="{ item }">
                  <div :class="borderColor(item.status)">
                    <div class="details-policy__table-padding">
                      {{ item.numero }}
                    </div>
                  </div>
                </template>
                <template v-slot:[`item.inicio_vigencia`]="{ item }">
                  {{ formatDateToDDMMYYYY(item.inicio_vigencia) }} a
                  {{ formatDateToDDMMYYYY(item.fim_vigencia) }}
                </template>
                <template v-slot:[`item.arquivo`]="{ item }">
                  <BaseButton
                    color="secondary"
                    class="px-0 mr-2 details-policy__button"
                    @click.stop="onPreviewFile(item)"
                    v-if="canSeeDocumentEndorsement"
                  >
                    <v-icon color="white">
                      fa-file
                    </v-icon>
                  </BaseButton>
                  <BaseButton
                    color="secondary"
                    class="px-0 details-policy__button"
                    @click.stop="showModalBills(item)"
                    v-if="hasBills(item)"
                  >
                    <v-icon color="white">
                      fa-barcode
                    </v-icon>
                  </BaseButton>
                </template>
              </BaseDataTable>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item class="pt-5">
          <HeaderEndorsementTable
            :canSeeRequestEndorsement="canSeeRequestEndorsement"
            :canSeeNewEndorsement="canSeeNewEndorsement"
          />
          <v-row class="pt-3">
            <v-col cols="12">
              <BaseDataTable
                :headers="headerRequest"
                :items="currentPolicy.solicitacoes_endossos"
                no-data-text="Nenhuma Solicitação de Endosso foi encontrada"
                loading-text="Carregando Solicitações de Endossos..."
                class="details-policy__table"
                hide-default-footer
                @click:row="editRequestEndorsement"
              >
                <template v-slot:[`item.numero`]="{ item }">
                  <div :class="borderColor(item.situacao)">
                    <div class="details-policy__table-padding">
                      {{ item.numero }}
                    </div>
                  </div>
                </template>
              </BaseDataTable>
            </v-col>
          </v-row>
        </v-tab-item>
      </BaseTab>
      <ModalDetailsStatusPolicy
        v-if="modal"
        v-model="modal"
        :item="currentPolicy"
        @close="closeModal"
      />
      <ModalListFiles
        v-model="modalDocuments"
        :items="currentListBills"
        @close="closeModalDocuments"
      />
      <ModalCancelPolicy
        v-if="modalCancel"
        v-model="modalCancel"
        @close="closeModalCancelPolicy"
        @submit="submitModalCancelPolicy"
        :number-policy="currentPolicy.numero"
        :type-modal="typeModal"
      />
    </fragment>
  </Main>
</template>
<script>
const tableHeaders = [
  { text: "N° Endosso", value: "numero", sortable: true },
  { text: "Tipo Endosso", value: "tipo.nome", sortable: true },
  { text: "Vigência", value: "inicio_vigencia", sortable: true },
  { text: "Solicitado por", value: "solicitado_por.nome", sortable: true },
  { text: "Status", value: "status.nome", sortable: true },
  { text: "Endosso/Boleto", value: "arquivo", sortable: true }
];
const tableHeadersRequest = [
  { text: "N° da Solicitação", value: "numero", sortable: true },
  { text: "Tipo", value: "tipo.nome", sortable: true },
  { text: "Status da Solicitação", value: "situacao.nome", sortable: true },
  { text: "Status das Críticas", value: "status_critica.nome", sortable: true }
];
const colorByStatus = {
  nao_vigente: "pink",
  vigente: "green"
};
import CardInfoPolicy from "../components/CardInforPolicy";
import CardOthersInfoPolicy from "../components/CardOthersInfoPolicy";
import { formatDateToDDMMYYYY, asMoneyString } from "@/utils/formats.js";
import ModalDetailsStatusPolicy from "../components/ModalDetailsStatusPolicy";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import ModalListFiles from "../components/ModalListFiles";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import ModalCancelPolicy from "../components/ModalCancelPolicy";
import HeaderEndorsementTable from "../components/HeaderEndorsementTable";
import CardPolicyCertificates from "../components/CardPolicyCertificates.vue";
import DocumentDataTable from "@/components/DocumentDataTable";

export default {
  data: () => ({
    header: tableHeaders,
    headerRequest: tableHeadersRequest,
    formatDateToDDMMYYYY,
    modal: false,
    modalDocuments: false,
    currentListBills: [],
    asMoneyString,
    modalCancel: false,
    typeModal: "Solicitação"
  }),
  components: {
    CardInfoPolicy,
    CardOthersInfoPolicy,
    ModalDetailsStatusPolicy,
    ModalListFiles,
    ModalCancelPolicy,
    HeaderEndorsementTable,
    CardPolicyCertificates,
    DocumentDataTable
  },
  mixins: [LoadingRequest, DocumentsMixin],
  created() {
    if (this.$route.params.id != this.currentPolicy.id) {
      this.resetState();
      this.setCurrentPolicyId(this.$route.params.id);
    }

    this.fetchCurrentPolicy();
  },
  computed: {
    ...mapState("policy", ["currentPolicy"]),
    ...mapState(["userPermissions"]),
    hasCurrentPolicy() {
      return this.currentPolicy.tomador.nome_fantasia;
    },
    hasAnexos() {
      return (
        this.currentPolicy.documentos_anexos != null &&
        this.currentPolicy.documentos_anexos.length > 0
      );
    },
    canSeeEditPolicy() {
      return (
        this.userPermissions.acoes.some(x => x.id == "editar_apolice") &&
        this.currentPolicy.acoes?.pode_editar
      );
    },
    canSeeRequestEndorsement() {
      return this.userPermissions.acoes.some(x => x.id == "solicitar_endesso");
    },
    canSeeNewEndorsement() {
      return this.userPermissions.acoes.some(x => x.id == "criar_endosso");
    },
    canAddNewEndorsement() {
      return (
        this.canSeeNewEndorsement &&
        this.currentPolicy.situacao?.id != "cancelada"
      );
    },
    canSeeEditEndorsement() {
      return this.userPermissions.acoes.some(x => x.id == "editar_endosso");
    },
    canSeeDocumentEndorsement() {
      return this.userPermissions.acoes.some(
        x => x.id == "visualizar_pdf_endosso"
      );
    },
    canSeeBillsEndorsement() {
      return this.userPermissions.acoes.some(
        x => x.id == "visualizar_pdf_boleto_endosso"
      );
    },
    canCancelPolicy() {
      return Boolean(this.currentPolicy.acoes?.pode_cancelar);
    },
    canRequestEndorsement() {
      return (
        this.currentPolicy.situacao?.id != "cancelada" &&
        this.currentPolicy.acoes?.pode_solicitar_endosso
      );
    },
    classButtonEditPolicy() {
      return this.canCancelPolicy
        ? "pb-7 pb-sm-0 pb-sm-0 pr-md-4"
        : "pb-7 pb-sm-0 pb-sm-0";
    },
    hasResquestToCancelPolicy() {
      return (
        this.currentPolicy.acoes?.pode_reprovar_cancelamento &&
        this.currentPolicy.tem_solicitacao_cancelamento_aberta
      );
    },
    classButtonCriticism() {
      return this.canSeeEditPolicy || this.canCancelPolicy ? "pr-sm-4" : "";
    }
  },
  methods: {
    ...mapActions("policy", [
      "requestCurrentPolicy",
      "requestCancelPolicy",
      "requestRefuseCancelPolicy",
      "resetState",
      "setCurrentPolicyId"
    ]),
    ...mapActions(["showAlertNotification"]),
    fetchCurrentPolicy() {
      this.withLoading(this.requestCurrentPolicy(this.$route.params.id));
    },
    hasBills(item) {
      return (
        item.boletos && item.boletos.length > 0 && this.canSeeBillsEndorsement
      );
    },
    borderColor(item) {
      return `details-policy__border-${colorByStatus[item.id]}`;
    },
    closeModal() {
      this.modal = false;
    },
    openModal() {
      this.modal = true;
    },
    closeModalDocuments() {
      this.modalDocuments = false;
    },
    openModalDocuments() {
      if (this.currentPolicy.boletos?.length == 1) {
        this.onPreviewFile(this.currentPolicy.boletos[0]);
      } else {
        this.currentListBills = this.currentPolicy.boletos;
        this.modalDocuments = true;
      }
    },
    newEndorsement() {
      this.$router.push({
        name: "new endorsement policy",
        params: { id: this.$route.params.id }
      });
    },
    newRequestEndorsement() {
      this.$router.push({
        name: "new endorsement request policy",
        params: { id: this.$route.params.id }
      });
    },
    editPolicy() {
      this.$router.push({
        name: "edit policy",
        params: { id: this.$route.params.id }
      });
    },
    showModalBills(item) {
      if (item.boletos?.length == 1) {
        this.onPreviewFile(item.boletos[0]);
      } else {
        this.currentListBills = item.boletos;
        this.modalDocuments = true;
      }
    },
    editEndorsement(item) {
      this.$router.push({
        name: "edit endorsement policy",
        params: { endosso: item.id, id: this.$route.params.id }
      });
    },
    editRequestEndorsement(item) {
      this.$router.push({
        name: "edit endorsement request policy",
        params: { endosso: item.id, id: this.$route.params.id }
      });
    },
    redirectToCriticism() {
      this.$router.push({
        name: "criticism policy",
        params: {
          id: this.currentPolicy.id
        }
      });
    },
    showModalCancelPolicy() {
      this.modalCancel = true;
      this.typeModal = "Solicitação";
    },
    showModalRefuseCancelPolicy() {
      this.modalCancel = true;
      this.typeModal = "Recusa";
    },
    closeModalCancelPolicy() {
      this.modalCancel = false;
    },
    submitModalCancelPolicy(form) {
      const action =
        this.typeModal == "Solicitação"
          ? this.requestCancelPolicy
          : this.requestRefuseCancelPolicy;
      const text = this.typeModal == "Solicitação" ? "solicitado" : "recusado";
      this.withLoading(
        action(this.payloadModalCancel(form)).then(() => {
          this.modalCancel = false;
          this.showAlertNotification({
            message: `Foi ${text} o cancelamento da apólice com sucesso!`,
            type: "success"
          });
          this.fetchCurrentPolicy();
        })
      );
    },
    payloadModalCancel(form) {
      return {
        payload: form,
        id: this.$route.params.id
      };
    }
  }
};
</script>
<style lang="sass">
.details-policy__
  &title
    align-self: center
  &card
    border: 1px solid #D5D5E0
    border-radius: 2px
    background-color: #F0F0F7
    @media(min-width: 960px)
      height: 285px
  &card-auto
    border: 1px solid #D5D5E0
    border-radius: 2px
    background-color: #F0F0F7
  &item
    border: 1px solid #D5D5E0
    border-radius: 4px
    background-color: #FFFFFF
  &button
    min-width: 40px !important
  &border-success
    border-left: 5px solid #49DCBB
  &border-green
    border-left: 5px solid #49DCBB
  &border-yellow
    border-left: 5px solid #FFC55F
  &border-pink
    border-left: 5px solid #EF5350
  &value
    font-size: 12px
    font-weight: 600
  &text-height
    line-height: 16px !important
  &title-height
    line-height: 18px !important
  &disclaimer
    @media(min-width: 600px) and (max-width: 960px)
      height: 40px
    @media(min-width: 1440px)
      height: 40px
    border-radius: 4px
  &money
    font-size: 25px
    font-weight: 800
    line-height: 18px
  &table.v-data-table.theme--light
    thead tr th
      padding: 8px 8px
    tbody tr td
      padding: 18px 8px
    tbody tr td:first-child
      padding: 2px 0px !important
  &table-padding
    padding: 0px 15px !important
    height: 36px !important
    display: flex
    align-items: center
.endorsement-list__
  &col
    align-self: center
  &tab
    .v-tabs-bar
      height: 50px !important
</style>
